module.exports = __webpack_public_path__ + "static/img/MONOCO-OAK.92f7447.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/MONOCO-OAK.png
// module id = +F1n
// module chunks = 0